import { useContextFallback } from '@prenuvo/halo-foundation';

import { ReportIssueContext } from './report-issue.context';

export const useReportIssue = () => useContextFallback(ReportIssueContext);
